import type { WorkToastItem } from "@/stores/work-toast-store";

const PREFIX = "computer:";

/** Store key of the standalone computer card for an execution. */
export function computerToastKey(executionId: string): string {
  return `${PREFIX}${executionId}`;
}

/** The execution behind a work toast: a standalone computer card's key minus its prefix. */
export function workToastExecutionId(
  item: Pick<WorkToastItem, "key" | "source">,
): string {
  return item.source === "computer" && item.key.startsWith(PREFIX)
    ? item.key.slice(PREFIX.length)
    : item.key;
}
